import React, { ReactChild, ReactElement, ReactNode } from 'react';
import { WizardStepNode } from './types';

export interface IWizardMetaProps {
  id: string;
  index: number;
  node: WizardStepNode;
  previousId: string | null;
  nextId: string | null;
  isLast: boolean;
  isFirst: boolean;
}

export class Meta {
  public steps: WizardStepNode[];

  constructor(__steps?: ReactChild[]) {
    const _steps = __steps || [];
    const steps = React.Children.toArray(_steps);

    this.steps = steps.filter((step: WizardStepNode) => {
      return step ? !step.props.ignore : false;
    }) as WizardStepNode[];

    // make sure that the steps have a unique id
    const ids = this.steps.map((step) => step.props.id);
    const unique = ids.filter(onlyUnique);

    if (ids.length !== unique.length) {
      throw new Error('Wizard.Step has duplicate id prop');
    }
  }

  public props(key: number | string) {
    const numSteps = this.steps.length;
    let id: string;
    let index: number;

    if (typeof key === 'string') {
      id = key;
      index = this.steps.findIndex((step: WizardStepNode) => step.props.id === id);
    } else {
      index = key;
      id = this.steps[index].props.id;
    }

    const previousIndex = index - 1 < 0 ? null : index - 1;
    const nextIndex = index + 1 >= numSteps ? null : index + 1;

    const props: IWizardMetaProps = {
      id,
      index,
      isFirst: index === 0,
      isLast: index === numSteps - 1,
      nextId: nextIndex != null ? this.steps[nextIndex].props.id : null,
      node: this.steps[index],
      previousId: previousIndex != null ? this.steps[previousIndex].props.id : null,
    };

    return props;
  }

  get first() {
    return this.props(this.steps[0].props.id);
  }

  get last() {
    return this.props(this.steps[this.steps.length - 1].props.id);
  }
}

// used by Array.filter to get an array of unique values
function onlyUnique(value: string, index: number, self: string[]) {
  return self.indexOf(value) === index;
}
